import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import styled from 'styled-components';
import { BUTTON_CIRCLE_SIZE, BUTTON_CIRCLE_SIZE_SMALL, BUTTON_CIRCLE_SIZE_TINY } from './constants';
import IconButton from './IconButton';
import { BACKGROUND_GRAY, LINE_GRAY, SENSATION_WHITE } from '../colors';
import { getPx } from '../helpers/common';
import { isDefined } from '../helpers/defined';
import { styleForBreakpoints } from '../helpers/media-style';
import { withOmitProps } from '../helpers/elements';
import { buttonBackgroundColorKeys, buttonBackgroundColorMixin } from './style/background-color';
import { buttonBoxShadowKeys, buttonBoxShadowMixin } from './style/box-shadow';
import { size } from '../style/size';
const SIZE = {
  tiny: BUTTON_CIRCLE_SIZE_TINY,
  small: BUTTON_CIRCLE_SIZE_SMALL,
  medium: BUTTON_CIRCLE_SIZE
};
const CircleButton = styled(IconButton).withConfig(withOmitProps([...buttonBackgroundColorKeys, ...buttonBoxShadowKeys]))`
  border-radius: 100%;
  ${buttonBoxShadowMixin}
  ${buttonBackgroundColorMixin}
  ${({
  $size,
  sizeVariant = 'medium'
}) => isDefined($size) ? size($size) : typeof sizeVariant === 'string' ? size(SIZE[sizeVariant] || SIZE.medium) : styleForBreakpoints(sizeVariant, (sizeVariant, breakpoint) => `
            width: ${getPx((SIZE[sizeVariant] || SIZE.medium)[breakpoint])};
            height: ${getPx((SIZE[sizeVariant] || SIZE.medium)[breakpoint])};
          `)}
`;
const CircleIconButton = /*#__PURE__*/React.forwardRef(({
  as,
  forwardedAs,
  size,
  sizeVariant = 'medium',
  ...props
}, forwardedRef) => {
  return /*#__PURE__*/React.createElement(CircleButton, _extends({
    forwardedAs: forwardedAs ?? as,
    ref: forwardedRef,
    size: null,
    $size: size,
    sizeVariant: sizeVariant,
    noShadow: false,
    noShadowActive: false,
    noShadowHover: false,
    noShadowFocus: false,
    noShadowDisabled: false,
    backgroundColor: SENSATION_WHITE,
    activeBackgroundColor: BACKGROUND_GRAY,
    hoverBackgroundColor: SENSATION_WHITE,
    focusBackgroundColor: SENSATION_WHITE,
    disabledBackgroundColor: LINE_GRAY
  }, props));
});
export default CircleIconButton;